import { useRef, useEffect } from 'react';
import Lottie from 'react-lottie';
import { GenericObject } from '../types/CommonConstans';

interface AnimateWithLottieProps {
  animationData: any;
  style?: GenericObject;
  width?: string;
  height?: string;
}

const defaultStyles = {
  marginLeft: '2rem',
  transform: 'translateX(-50%)',
  position: 'absolute',
  left: '45%'
};

const AnimateWithLottie = (props: AnimateWithLottieProps) => {
  const { animationData, style, width = '38rem', height = '6rem' } = props;
  const animationRef = useRef<HTMLDivElement>(null);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Lottie
      options={defaultOptions}
      height={height}
      width={width}
      style={style ? style : defaultStyles}
    />
  );
};

export default AnimateWithLottie;
